import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Carousel,
  GridColumn,
  GridRow,
  LazyImg,
} from "arv-reactcomponents";
import LazyLoad from 'react-lazyload';
import { generateDateFormat, ToCurrency } from "../../utils";
import Anchor from "../Anchor";
import { Endpoints, ORDERDETAILS } from "npmlinks-constants";

const { MY_ORDERS } = ORDERDETAILS;

class MyOrderGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      defaultMainImage: null,
    };
    this.onSwipe = this.onSwipe.bind(this);
    this.renderItems = this.renderItems.bind(this);
    this.scroll = this.scroll.bind(this);
    this.onImgLoadError = this.onImgLoadError.bind(this);
  }
  static setStatusClassName(className) {
    // create class name format: In Progress => is-in-progress
    const name = className
      .toLowerCase()
      .split(" ")
      .join("-");
    return `is-${name}`;
  }
  static columnSide(index) {
    return index % 2 === 0 ? "nw-order-sectionleft" : "nw-order-sectionright";
  }
  scroll(type) {
    const { currentIndex } = this.state;
    const newIndex = type === "next" ? currentIndex + 1 : currentIndex - 1;
    if (newIndex > -1 && newIndex < this.props.data.imagesList.length) {
      this.setState({ currentIndex: newIndex });
    }
  }
  onSwipe(direction) {
    if (!direction.vertical) {
      this.scroll(direction.horizontal);
    }
  }

  onImgLoadError() {
    this.setState({
      defaultMainImage: Endpoints.noImg,
    });
  }

  renderItems(item, index) {
    const activeClass = index === this.state.currentIndex ? "is-active" : "";
    return (
      <div className={`nw-ordergrid-carouselimg ${index} ${activeClass}`}>
        <LazyLoad>
        <LazyImg
          className="nw-thumbnail-imagelazy"
          index={index}
          src={item}
          rootMargin={`1500px`}
          onError={this.onImgLoadError}
          onWinLoad
        />
        </LazyLoad>
      </div>
    );
  }

  render() {
    const { data, index } = this.props;
    const { currentIndex } = this.state;
    return (
      <GridRow
        className={`nw-ordergrid-wrapper ${MyOrderGrid.columnSide(index)}`}
      >
        <GridColumn className="nwc-grid-col-xs nw-ordergrid-img">
          {data.imagesList.length > 1 ? (
            <Button
              disabled={currentIndex === 0}
              className="nwc-btn-primary-txt nw-ordergrid-carouselbtn nw-ordergrid-carouselbtnprev"
              onClick={() => this.scroll("prev")}
            >
              <i className="icomoon-arrow_left nw-ordergrid-carouselbtnicon" />
            </Button>
          ) : (
            ""
          )}
          <Carousel
            className="nw-ordergrid-carousel"
            index={this.state.currentIndex}
            items={data.imagesList}
            renderItems={this.renderItems}
            onSwipe={this.onSwipe}
          />

          {data.imagesList.length > 1 ? (
            <Fragment>
              <Button
                disabled={currentIndex === data.imagesList.length - 1}
                className="nwc-btn-primary-txt nw-ordergrid-carouselbtn nw-ordergrid-carouselbtnnext"
                onClick={() => this.scroll("next")}
              >
                <i className="icomoon-arrow_right nw-ordergrid-carouselbtnicon" />
              </Button>
              <div className="nw-ordergrid-dotswrapper">
                {`${this.state.currentIndex + 1}/${data.imagesList.length}`}
              </div>
            </Fragment>
          ) : (
            ""
          )}
        </GridColumn>
        <Anchor.component
          href={`/orderdetails/${data.orderId}`}
          to={`/orderdetails/${data.orderId}`}
          className="nw-ordergrid-anchor"
        >
          <GridColumn className="nwc-grid-col-xs nw-ordergrid-content">
            <span
              className={`nw-ordergrid-id ${MyOrderGrid.setStatusClassName(
                data.orderStates.orderStatusToCustomer,
              )}`}
            >{`#${data.orderId}`}</span>
            <span
              className={`nw-ordergrid-status ${MyOrderGrid.setStatusClassName(
                data.orderStates.orderStatusToCustomer,
              )}`}
            >
              {data.orderStates.orderStatusToCustomer}
            </span>
            <span
              className={`nw-ordergrid-info ${MyOrderGrid.setStatusClassName(
                data.orderStates.orderStatusToCustomer,
              )}`}
            >
              {generateDateFormat(data.orderDate)} | {data.itemsCount}
              &nbsp;
              {data.itemsCount > 1 ? "products" : "product"}
            </span>
            <span
              className={`nw-ordergrid-price ${MyOrderGrid.setStatusClassName(
                data.orderStates.orderStatusToCustomer,
              )}`}
            >
              {ToCurrency(data.finalPrice)}
            </span>

            <div className="nw-order-button nwc-btn nwc-btn-primary">
              {MY_ORDERS.BUTTON_TEXT}
            </div>
          </GridColumn>
        </Anchor.component>
      </GridRow>
    );
  }
}

MyOrderGrid.propTypes = {
  data: PropTypes.shape([]).isRequired,
  index: PropTypes.number.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: MyOrderGrid,
  component: MyOrderGrid,
};

export default ProjectComponent;
